import React from 'react'

const HeroImage = ({ hasP0 = false, ...props }) => {
  const imageSrc = hasP0
    ? 'https://img.uswitch.com/n36b8lzdmgnp/5flbZO4Cv7vcmoY2G49Mxr/c24b57f82030e66405eb0591a09f47ab/bb-results-stickers.svg'
    : 'https://img.uswitch.com/n36b8lzdmgnp/6qZCUg3m2sFQsjrmU1qPDh/4862b80d04b0f86f52e744ea5899aaaf/bb-stickers__1_.svg'

  return <img src={imageSrc} alt='' {...props} />
}

export default HeroImage
